import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import { SlidersHorizontal } from 'lucide-react';
import { ORGANIZATION_SORT_OPTIONS } from '../constants';
import type { OrganizationSortKey } from '../interfaces';

interface IOrganizationsToolbarProps {
  sortKey: OrganizationSortKey;
  onSortChange: (key: OrganizationSortKey) => void;
}

export const OrganizationsToolbar: React.FC<IOrganizationsToolbarProps> = ({
  sortKey,
  onSortChange,
}) => (
  <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { md: 'center' }, justifyContent: 'space-between', gap: 2 }}>
    <Stack direction="row" spacing={3} alignItems="center">
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          Sort By:
        </Typography>
        <Select
          size="small"
          value={sortKey}
          onChange={(e) => onSortChange(e.target.value as OrganizationSortKey)}
          sx={{
            fontWeight: 700,
            fontSize: '0.8125rem',
            '& .MuiSelect-select': { py: 0.5, px: 1 },
          }}
        >
          {ORGANIZATION_SORT_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </Stack>
      <Button
        startIcon={<SlidersHorizontal size={16} />}
        variant="text"
        size="small"
        sx={{
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          fontWeight: 700,
          fontSize: '0.75rem',
          '&:hover': { color: 'primary.main' },
        }}
      >
        Advanced Filters
      </Button>
    </Stack>
  </Box>
);
